.alert {
  margin-bottom: 32px;
  padding: 16px;
  border-radius: 8px;

  &.error {
    background-color: rgb(253, 237, 237);
    text-overflow: ellipsis;
    overflow-x: hidden;
    max-height: 200px;
  }

  &.success {
    background-color: rgba(36, 206, 134, 0.5);
  }
}

.label {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 13px;
}

.errorMessage {
  padding-left: 4px;
  margin-top: 4px;
  margin-bottom: 0;
  font-weight: 400;
  font-size: 12px;
  color: #f04f2b;
}

.inputRow {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
}

.input {
  padding: 16px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #dfe1e4;

  outline: none;

  &:hover {
    border-color: #3597fc;
  }

  &:focus {
    border-color: #1f5be4;
  }

  &.error {
    border-color: #f04f2b;
  }
}

.button {
  padding: 16px;
  background-color: #1f5be4;
  border-radius: 8px;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  width: 100%;

  &:hover {
    background-color: #3597fc;
  }

  &:disabled {
    background-color: #b6c5dc;
  }
}
